// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3hETY","location":"Header_location__1tN6u"};